import { axios } from '../utils/http'
// C8.0 商城首页会员卡信息
export const queryCardProducts = (params) => axios(params, '/card/queryCardProducts')
// C8.0 商城首页卖品列表
export const getGoods = (params) => axios(params, '/cretail/goods/getGoods')
// C8.0 卖品确人订单
export const order_confirm = (params) => axios(params, '/trade/order/confirm')
// C8.0 超值卡包列表
export const getCardHolder = (params) => axios(params, '/cretail/card/getCardHolder')
// C8.0 查询卡包详情
export const getCardHolderDetail = (params) => axios(params, '/cretail/card/getCardHolderDetailV2')
// 购买卡包
export const buyCardHolder = (params) => axios(params, '/trade/order/buyCardHolder')
// 卖品列表-新增配送到家
export const queryGoods = (params) => axios(params, '/cretail/goods/queryGoods')
// 购买卖品详情
export const getGoodsDetail = (params) => axios(params, '/cretail/goods/getGoodsDetail')


// WEBPACK FOOTER //
// ./src/api/shop.js